import { render, staticRenderFns } from "./NMapMarker.vue?vue&type=template&id=2a4a5d81&"
import script from "./NMapMarker.vue?vue&type=script&lang=ts&"
export * from "./NMapMarker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports